module.exports = __webpack_public_path__ + "img/icons for DS Logistik SPIM.-14.7f9e6851.svg";